var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnesthesia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "anaesthesiology-01",
    transform: "translate(0.25 0.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2136",
    "data-name": "Group 2136",
    transform: "translate(-6.737 -1.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M26.181,2.776l2.032-1.013L27.788,5.4l2.187-1.089",
    fill: "none",
    stroke: "#5adbb6",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M23.926,4.753l1.208-.6-.253,2.162,1.3-.648",
    fill: "none",
    stroke: "#5adbb6",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2151",
    "data-name": "Group 2151",
    transform: "translate(-6.737 -1.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M28.124,30.237V24.8c0-3.649-1.63-3.736-7.493-5.5H14.04c-4.289,1.583-7.3,1.855-7.3,5.5v5.433Z",
    fill: "#2b5889",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M20.931,20.757a31.859,31.859,0,0,1-1.351-4.932,5.073,5.073,0,0,1-1.127.107c-.335-.008-.664-.03-.99-.057V15.86l-.1.007-.1-.008v.015c-.326.024-.655.042-.99.046a5,5,0,0,1-1.126-.119,31.992,31.992,0,0,1-1.4,4.917c-.949,2.615,2.93,2.68,3.581,2.673C17.972,23.405,21.852,23.382,20.931,20.757Z",
    fill: "#f5caa2",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M14.564,16.718a2.745,2.745,0,0,0,2.853,2.021,2.744,2.744,0,0,0,2.853-2.021Z",
    fill: "#161b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M10.943,11.727c-.013-1,.287-1.817.917-1.825a.879.879,0,0,1,.332.067c-.022-.28-.037-.481-.043-.566a.842.842,0,0,1,0-.1c0-.007,0-.017,0-.024h0c0-.018,0-.038,0-.061s0-.017,0-.026,0-.038,0-.06,0-.032,0-.049,0-.037,0-.057,0-.045.006-.069,0-.037.005-.057.006-.058.009-.088,0-.035.006-.054c0-.034.009-.07.014-.107,0-.017.005-.034.007-.052.006-.04.012-.081.019-.123,0-.017.005-.033.008-.049.008-.045.016-.092.025-.139l.009-.048c.01-.049.021-.1.032-.15,0-.016.007-.031.01-.047.012-.053.025-.107.039-.161,0-.015.007-.03.011-.045.015-.056.031-.113.047-.17.005-.015.008-.03.013-.046.017-.058.036-.116.056-.176l.015-.046c.02-.06.042-.12.065-.181.006-.015.011-.03.017-.046.024-.061.049-.122.075-.184.007-.015.013-.03.019-.046.027-.062.055-.124.085-.186.007-.015.014-.031.022-.047.03-.062.062-.123.1-.184.009-.016.016-.032.025-.048.034-.061.069-.121.106-.182l.029-.049c.037-.06.076-.119.117-.178l.033-.05c.04-.058.084-.115.128-.172.013-.017.025-.034.039-.051.044-.056.091-.111.139-.165.015-.017.029-.035.045-.052q.072-.079.15-.156l.051-.053c.051-.05.106-.1.161-.146.02-.018.038-.036.059-.053.055-.047.113-.091.171-.136l.067-.052c.059-.043.121-.084.183-.125.025-.017.05-.035.076-.051.062-.039.128-.076.194-.113.029-.016.056-.033.086-.049.066-.035.135-.067.2-.1.033-.015.063-.032.1-.046.07-.031.144-.059.217-.087.036-.014.07-.029.106-.042.073-.026.149-.048.225-.072.041-.013.08-.027.122-.038.077-.022.158-.039.239-.058.044-.01.086-.022.131-.031.083-.017.17-.03.256-.044.047-.008.092-.017.14-.024.092-.013.188-.021.284-.03.046,0,.09-.011.137-.014.145-.01.293-.017.447-.019s.292,0,.432.007c.046,0,.09.007.135.01.092.006.185.012.273.022.052.005.1.013.151.019.079.01.158.021.235.034l.15.029c.072.014.144.029.213.046l.144.038c.067.018.134.037.2.057l.134.044c.064.022.127.045.188.07l.123.05c.062.026.121.054.18.082.037.018.074.035.11.054.061.031.119.063.177.1l.093.053c.062.037.122.077.181.117.023.016.048.031.07.047.072.051.142.1.209.157l.024.018a4.155,4.155,0,0,1,.422.391l.035.039c.05.055.1.11.147.166l.047.058c.041.051.082.1.121.154l.047.066c.036.05.071.1.1.151l.045.07c.032.05.064.1.094.152l.041.07c.029.051.057.1.085.154l.036.069c.027.053.052.105.077.158.01.021.021.043.03.064.025.056.049.111.073.167.007.018.015.036.022.053.025.062.049.123.072.184l.013.033c.054.147.1.29.14.428l0,.01c.018.064.035.127.051.188,0,.018.009.036.013.054.011.046.022.091.032.135,0,.024.01.046.015.069s.016.073.023.109.01.05.014.074.011.062.017.092.009.051.013.076.008.05.012.075.008.054.011.08,0,.038.007.056.007.054.01.08,0,.025,0,.038c0,.029.006.057.009.083v0h0c.01.1.015.181.017.229a.834.834,0,0,1,0,.1c0,.085-.013.288-.028.568a.884.884,0,0,1,.33-.076c.631-.008.952.8.965,1.8a2.028,2.028,0,0,1-1.572,1.826,9.791,9.791,0,0,1-.407,2.092c-.613,1.492-2.881,2.678-4.387,2.7a5.48,5.48,0,0,1-4.535-2.58,7.006,7.006,0,0,1-.462-2.08A2.034,2.034,0,0,1,10.943,11.727Z",
    fill: "#f5caa2",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M17.417,10.063l.689,2.931s.074.609-.479.646h-.876",
    fill: "none",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M16.5,15.387a2.44,2.44,0,0,0,2.067-.074",
    fill: "none",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M16.779,2.543c4.868-1.449,5.309,2.775,5.309,2.775a2.521,2.521,0,0,1,1.144.953c.347.635-.151,4.038-1.1,5.3-.73-1.122-.968-4.438-.968-4.438-1.942-.735-7.749-.019-7.749-.019s.115,3.524-.9,4.342C10.392,6.862,12.373,3.855,16.779,2.543Z",
    fill: "#2c355e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M14.008,13.953c0-2.532,1.482-2.849,3.427-2.849s3.618.317,3.618,2.849-1.577,4.584-3.523,4.584S14.008,16.485,14.008,13.953Z",
    fill: "#fff",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M12.623,29.92v-3.5",
    fill: "none",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M22.537,29.92v-3.5",
    fill: "none",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M18.548,16.291H16.514V14.976a1.017,1.017,0,0,1,1.017-1.017h0a1.017,1.017,0,0,1,1.017,1.017Z",
    fill: "#5ba5ed",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2150",
    "data-name": "Group 2150"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1325",
    "data-name": "Rectangle 1325",
    width: 1.102,
    height: 13.946,
    transform: "translate(16.938 16.291)",
    fill: "#fff",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_154",
    "data-name": "Line 154",
    x2: 1.103,
    transform: "translate(16.938 18.016)",
    fill: "none",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_155",
    "data-name": "Line 155",
    x2: 1.103,
    transform: "translate(16.938 19.3)",
    fill: "none",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_156",
    "data-name": "Line 156",
    x2: 1.103,
    transform: "translate(16.938 20.656)",
    fill: "none",
    stroke: "#2c355e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnesthesia);
export default __webpack_public_path__ + "static/media/anesthesia.eb2231e0964980e3b9fa3bb315091d11.svg";
export { ForwardRef as ReactComponent };